import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

//import language json files for add to resources
import enTranslation from './multiLanguages/english.json';
import esTranslation from './multiLanguages/spanish.json';

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        debug: false, // if enables, can check the i18n object to debug 
        resources: {
            en: {
                translation: enTranslation,
            },
            es: {
                translation: esTranslation,
            },
        },
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
